<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Contratos">
          <cadastro
            v-if="showForm"
            :contratoEdit="contratoEdit"
            :contratoASerDistribuido="contratoASerDistribuido"
            @close="close"
          />
          <editar
            v-else-if="showFormEdit"
            :contratoASerEditado="contratoASerEditado"
            @close="close"
          />
          <relatorio
            v-else-if="showFormRelatorio"
            :contrato="contrato"
            @close="close"
          />
          <listar
            v-else
            @showForm="showForm = true"
            @editItem="editItem"
            @distribuirParaTransportadora="handleDistribuirParaTransportadora"
            @editar="handleEditar"
            @showRelatorio="showRelatorio"
          />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Listar from '@/components/patio/ContratoCargaDescarga/Listar'
import Cadastro from '@/components/patio/ContratoCargaDescarga/Cadastro'
import Editar from '@/components/patio/ContratoCargaDescarga/Editar'
import Relatorio from '@/components/patio/ContratoCargaDescarga/Relatorio'

export default {
  name: 'Contrato',

  data() {
    return {
      showForm: false,
      showFormEdit: false,
      showFormRelatorio: false,
      contrato: {},
      contratoEdit: {},

      contratoASerEditado: {},

      contratoASerDistribuido: {},

      page: {
        title: 'Gerenciamento de Contratos',
      },
      breadcrumbs: [
        {
          text: 'Comercial',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Contratos',
          disabled: true,
        },
      ],
    }
  },
  components: {
    Listar,
    Cadastro,
    Editar,
    Relatorio,
  },
  methods: {
    showRelatorio(item) {
      this.showFormRelatorio = true
      this.contrato = { ...item }
    },
    editItem(item) {
      this.showForm = true
      this.contratoEdit = { ...item }
    },

    close() {
      this.showForm = false
      this.showFormEdit = false
      this.showFormRelatorio = false
      this.contratoEdit = {}
      this.contratoASerDistribuido = {}
      this.contratoASerEditado = {}
      this.contrato = {}
    },

    handleDistribuirParaTransportadora(item) {
      this.contratoASerDistribuido = item
      this.showForm = true
    },
    handleEditar(item) {
      this.contratoASerEditado = item
      this.showFormEdit = true
    },
  },
}
</script>

<style></style>
